/** Components that is used by the form */

import React, { type FC } from 'react'
import type { FormComponentProps } from './form-component.js'

export const FormComponentContext = React.createContext<Record<string, FC<FormComponentProps>> | null>(null)
